module.exports = __webpack_public_path__ + "img/left.fa81e8fe.png";